import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=ac2c7174&scoped=true&"
var script = {}
import style0 from "./Preloader.vue?vue&type=style&index=0&id=ac2c7174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2c7174",
  null
  
)

export default component.exports